module.exports = (__webpack_require__(42547))(96540);